import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { GetCustomer } from '../../store/actions/customer.actions';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { CustomerInterfaceState } from '../../store/state/customer.state';
import { CustomerInterface } from '../../models/customer.interface';
import { environment } from '../../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CustomerMsisdnNotificationPaginatorInterface } from '../../../shared/models/customer-msisdn-notification-paginator.interface';
import { MsisdnNotificationsInterfaceState } from '../../../shared/store/state/msisdn-notifications.state';
import {
  DeleteCustomerNotifications,
  GetCustomerNotifications
} from '../../../shared/store/actions/customer-msisdn-notifications.actions';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { CheckPasswordInterfaceState } from '../../../shared/store/state/check-password.state';
import { UpdateCheckPasswordVisibility } from '../../../shared/store/actions/check-password.actions';
import { ExtranetService } from '../../../shared/services/extranet.service';
import { SupportUserInterface } from '../../../shared/models/support-user.interface';
import { SelectedProcedureInterfaceState } from '../../../shared/store/state/selected-procedure.state';
import moment from 'moment';

@Component({
    selector: 'app-account-details',
    templateUrl: './account-details.component.html',
    styleUrls: ['./account-details.component.css'],
    standalone: false
})

export class AccountDetailsComponent implements OnInit {

  customer: CustomerInterface;
  environment = environment;
  informationTab: string;
  addressTab: string;
  paymentTab: string;
  managementAccountTab: string;
  notificationsTab: string;
  notificationsPaginator: CustomerMsisdnNotificationPaginatorInterface;
  faqPageCode: string;
  supportUser: SupportUserInterface;
  selectedProcedure: string;
  constHelper = ConstsHelper;
  brand?: string;
  handleRgpd: boolean;
  isPro: boolean;

  constructor(
      private store: Store<any>,
      private router: Router,
      private activateRoute: ActivatedRoute,
      private location: Location,
      private extranetService: ExtranetService
  ) {}

  ngOnInit() {
    this.isPro = false;
    this.store.pipe(select(ConstsHelper.REDUCER_CHECK_PASSWORD)).subscribe((response: CheckPasswordInterfaceState) => {
      if (response.result != null && response.result.page === 'info') {
        if (response.result.isValid === true) {
          this.router.navigate(['compte/modifier']);
        }
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_SELECTED_PROCEDURE)).subscribe((response: SelectedProcedureInterfaceState) => {
      if (response.code != null) {
        this.selectedProcedure = response.code;
        this.handleRgpd = false;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER)).subscribe( (result: CustomerInterfaceState) => {
      if (null != result.customer) {
        this.customer = result.customer;
        this.isPro = [null, ''].indexOf(this.customer.siret) == -1;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER_MSISDN_NOTIFICATIONS)).subscribe((response: MsisdnNotificationsInterfaceState) => {
      if (response.result != null) {
        this.notificationsPaginator = response.result;
      }
    });

    this.brand = environment.data.brand;
    this.handleRgpd = false;
    this.store.dispatch(new GetCustomerNotifications('account', 1, 5));
    this.store.dispatch(new GetCustomer());
    this.setActiveTab(this.activateRoute.snapshot.params['tab'], false);
    this.supportUser = this.extranetService.getSupportUser();
    this.customer = null;
    this.selectedProcedure = null;
  }

  updatePage() {
    if (this.extranetService.getSupportUser()) {
      this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: true, password: null, page: 'info'}));
    } else {
      this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: true, isValid: null, password: null, page: 'info'}));
    }
  }

  formatDate(birthDate: string) {
    return moment(birthDate, 'DD-MM-YYYY').format('DD/MM/YYYY');
  }

  setActiveTab(tab: string, resetSelectedProcedure: boolean) {
    this.informationTab = '';
    this.addressTab = '';
    this.paymentTab = '';
    this.managementAccountTab = '';
    this.notificationsTab = '';
    if (['', 'undefined', undefined].indexOf(tab) !== -1) {
      tab = 'infos';
      this.faqPageCode = 'account_infos';
    }

    switch (tab) {
      case 'infos':
        this.informationTab = 'active';
        this.faqPageCode = 'account_infos';
        break;
      case 'adresses':
        this.addressTab = 'active';
        this.faqPageCode = 'account_adresses';
        break;
      case 'paiement':
        this.paymentTab = 'active';
        this.faqPageCode = 'account_paiement';
        break;
      case 'gestion':
        this.managementAccountTab = 'active';
        this.faqPageCode = 'account_gestion';
        break;
      case 'notifications':
        this.notificationsTab = 'active';
        this.faqPageCode = 'account_notifications';
        if (
            this.notificationsPaginator &&
            this.notificationsPaginator.totalUnread > 0 &&
            this.notificationsPaginator.data.length > 0 &&
            this.supportUser == null
        ) {
          this.store.dispatch(new DeleteCustomerNotifications(this.notificationsPaginator.data[0].id));
        }
        break;
    }
    if (resetSelectedProcedure) {
      this.store.dispatch(new UpdateSelectedProcedure(''));
      localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_UPDATE_SHIPPING_ADDRESS_LOST_STEAL_PROCEDURE);
    }
    if (['infos', 'adresses', 'paiement', 'gestion', 'notifications'].indexOf(tab) !== -1) {
      this.location.replaceState('/compte/' + tab);
    }
  }
}
